import { Link } from "react-router-dom";
import Header from "@/components/Header";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen">
      <Header inApp />
      <div className="max-w-md mx-auto px-4 py-16">
        <Card className="tactile-card p-8 rounded-md text-center" data-testid="payment-cancel-card">
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#606872]">CHECKOUT CANCELLED</div>
          <h1 className="font-display text-2xl font-bold mt-1 tracking-tight">No charge made.</h1>
          <p className="text-sm text-[#A0A7B0] mt-2">You can still explore your leaks in demo mode.</p>
          <Link to="/dashboard"><Button className="btn-emerald mt-6 w-full h-11" data-testid="cancel-back-dashboard">Back to dashboard</Button></Link>
        </Card>
      </div>
    </div>
  );
}
